/**
 * Punto de entrada principal de la aplicación React.
 * Configura el renderizado en el DOM y carga los estilos globales.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
